module.exports = __webpack_public_path__ + "img/SKL Family Club.991e73c4.png";